import { Component, OnInit }  from '@angular/core';
import { ActivatedRoute }     from '@angular/router';

@Component({
  selector: 'app-error-settings',
  templateUrl: './error-settings.component.html',
  styleUrls: ['./error-settings.component.css']
})
export class ErrorSettingsComponent implements OnInit {

  error_code_message = {};
  error_message      = "";

  constructor(
      private _route            : ActivatedRoute
      ) 
  { 
    this.error_code_message["100"] = "generic.get_settings_error";
    this.error_code_message["200"] = "generic.secondary_address_error";
  }

  ngOnInit() 
  {
    var error_code   = +this._route.snapshot.paramMap.get('errorcode');
    if (error_code !== 0 || error_code !== null || error_code !== undefined)
    {
        if (this.error_code_message[error_code] === undefined)
        {
          error_code = 100;
        }
        this.error_message = this.error_code_message[error_code];
    }


  }

}
